(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aaronya-commissions"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ap-art-compare')) {
  customElements.define('ap-art-compare', class extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input');
      if (!input || this.bound) return;
      this.bound = true;
      input.addEventListener('input', () => this.style.setProperty('--reveal', input.value + '%'));
    }
  });
}
if (!customElements.get('ap-art-formats')) {
  customElements.define('ap-art-formats', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button || this.bound) return;
      this.bound = true;
      this.querySelectorAll('[data-format]').forEach(link => {
        link.addEventListener('click', () => {
          const select = this.closest('.ap-commission').querySelector('#ap-commission-format');
          if (select) select.value = link.dataset.format;
        });
      });
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  if (!document.documentElement.hasAttribute('data-aaronya-filter-shortcuts')) {
    document.documentElement.setAttribute('data-aaronya-filter-shortcuts', '');
    document.addEventListener('click', (event) => {
      const shortcut = event.target.closest('[data-aaronya-filter-shortcut]');
      if (!shortcut) return;

      const target = shortcut.dataset.aaronyaFilterShortcut;
      window.setTimeout(() => {
        const drawer = document.querySelector('#filters-drawer');
        if (!drawer) return;

        const detailsGroups = Array.from(drawer.querySelectorAll('details'));
        if (target !== 'all') {
          detailsGroups.forEach((details) => {
            details.open = false;
          });
        }

        const drawerScroller = drawer.querySelector('.facets-drawer__filters');
        if (drawerScroller) drawerScroller.scrollTop = 0;

        if (target === 'all') {
          detailsGroups.forEach((details) => {
            const label = details.querySelector('summary')?.textContent.trim().toLowerCase() || '';
            details.open =
              details.classList.contains('aaronya-mobile-browse__panel') ||
              label.startsWith('orientation');
          });
          const drawerHeading = drawer.querySelector('#filters-drawer-heading');
          drawerHeading?.focus();
          return;
        }

        if (target === 'sort') {
          const sortSummary = Array.from(drawer.querySelectorAll('summary')).find((item) =>
            item.textContent.trim().toLowerCase().startsWith('sort')
          );
          const sortDetails = sortSummary?.closest('details');
          if (sortDetails) sortDetails.open = true;
          sortSummary?.focus();
          sortSummary?.scrollIntoView({ block: 'start' });
          return;
        }

        const summaries = Array.from(drawer.querySelectorAll('summary'));
        const summary = summaries.find((item) => item.textContent.trim().toLowerCase().startsWith(target));
        if (!summary) return;

        const details = summary.closest('details');
        if (details) details.open = true;
        summary.focus();
        summary.scrollIntoView({ block: 'center' });
      }, 180);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
